var map = {
	"./Discord.png": "XVFy",
	"./Facebook.png": "ffMZ",
	"./Instagram.png": "KWgl",
	"./Naver.png": "7PYr",
	"./TikTok.png": "l8Zy",
	"./Twitch.png": "eF7t",
	"./VK.png": "x2Sq",
	"./X.png": "X2A9",
	"./YouTube.png": "14Zu",
	"./pc_icon_flyout.png": "S6AS",
	"./share-icon.png": "0ZiA",
	"./xfe-layer-10.png": "9aAh",
	"./xfe-layer-11.png": "Fs/z",
	"./xfe-layer-12.png": "4Dfk",
	"./xfe-layer-13.png": "9mhj",
	"./xfe-layer-14.png": "iVMu",
	"./xfe-layer-15.png": "/891",
	"./xfe-layer-20.png": "COBC",
	"./xfe-layer-6.png": "ShAR",
	"./xfe-layer-7.png": "dHRI",
	"./xfe-layer-8.png": "Lg1P",
	"./xfe-layer-9.png": "Zfez"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "v5Jv";